import Button from 'syf-component-library/ui/atoms/Button'
import SimpleModal from 'syf-component-library/ui/patterns/SimpleModal'
import styled from 'styled-components'
import { H1 } from 'syf-component-library/ui/typography'
import Icon from 'ui/atoms/Icon'
import mediaQueries from 'mediaQueries'
import { getContainerCss } from 'ui/molecules/ModalHeader/helpers'
import { RefObject } from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export interface StyledProps {
  primary?: string
  secondary?: string
  ref?: RefObject<HTMLHeadingElement>
  icon?: IconProp
  onClick?: () => void
  tabindex?: string
}

export const CoBrowseModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Modal = styled(SimpleModal)`
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 82%;
  min-width: 85%;
  border-radius: 6px;
  z-index: 5;
  & .modalHeader {
    min-height: 47px;
  }
  @media ${mediaQueries.greaterThanSmall} {
    min-width: 250px;
    width: 360px;
    height: auto;
  }
`

export const HeaderText = styled(H1)<StyledProps>`
  font-size: 18px;
  color: ${({ secondary, theme }): string => secondary || theme.modal.text};
`

export const ModalClose = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  border: none;
  background: none;
`

export const CloseIcon = styled(Icon)<StyledProps>`
  font-size: 24px;
  cursor: pointer;
  color: ${({ secondary, theme }): string => secondary || theme.modal.text};
`

export const Container = styled.div`
  width: 100%;
`

export const ContainerHeader = styled.div<StyledProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px 0 16px;
  min-height: 80px;
  ${({ theme, primary }) => getContainerCss({ theme, primary })}
  @media ${mediaQueries.greaterThanSmall} {
    padding: 0 32px;
  }
`

export const Text = styled.div`
  margin: 16px;
  @media ${mediaQueries.greaterThanSmall} {
    margin: 32px;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 8px 0 8px;
  @media ${mediaQueries.greaterThanSmall} {
    padding: 0 16px 16px 16px;
  }
`

export const PrimaryButton = styled(Button)`
  width: 296px;
  font-weight: bold;
`
export const SecondaryButton = styled(Button)`
  font-weight: bold;
  width: 296px;
  border: 2px solid;
`
